import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";

import PhotoUploadSectionContainer from "../PhotoUploadCore/PhotoUploadSectionContainer";
import PhotoUploadTypeSelectMasthead from "./PhotoUploadTypeSelectMasthead";
import PhotoUploadTypeSelectFooter from "./PhotoUploadTypeSelectFooter";
import Link from "core/Link";
import RedirectOnInvalidReferrer from "../PhotoUploadCore/RedirectOnValidReferrer";

import breakpoints from "core/breakpoints";
import MobileError from "../Status/Mobile";

import { GuidelinesMessage } from "./styles";

import PhotoUploadProviders from "../PhotoUploadCore/PhotoUploadProviders";

import { usePhotoUploadRedirect } from "../PhotoUploadCore/hooks";

import { UPLOAD_TYPES } from "../PhotoUploadCore/helpers";
import { updateQueryParams, useCurrentUploadType } from "./helpers";
import { useViewport } from "js/hooks/useViewport";

const PhotoUploadTypeSelectLayout = ({ history, location }) => {
    const { setCurrentUploadType, currentUploadType } = useCurrentUploadType(
        location
    );

    const { browserWidth } = useViewport();
    const isMobile = browserWidth < breakpoints.tablet.px;

    useEffect(() => {
        updateQueryParams(history, location, currentUploadType);
    }, [currentUploadType]);

    const handleSubmit = e => {
        setSelectionConfirmed(true);
    };

    const [selectionConfirmed, setSelectionConfirmed] = useState(false);

    const {
        RedirectToIndividualUploadPage,
        RedirectToPhotoShootUploadPage
    } = usePhotoUploadRedirect(location);

    if (selectionConfirmed) {
        if (currentUploadType === UPLOAD_TYPES.INDIVIDUAL)
            return <RedirectToIndividualUploadPage />;
        if (currentUploadType === UPLOAD_TYPES.PHOTO_SHOOT)
            return <RedirectToPhotoShootUploadPage />;
    }

    return (
        <>
            <RedirectOnInvalidReferrer />
            {isMobile ? (
                <MobileError />
            ) : (
                <>
                    <PhotoUploadSectionContainer>
                        <PhotoUploadTypeSelectMasthead
                            setCurrentUploadType={setCurrentUploadType}
                            currentUploadType={currentUploadType}
                        />
                        <GuidelinesMessage>
                            For more information, please read our{" "}
                            <Link href="/tbd">guidelines.</Link>
                        </GuidelinesMessage>
                    </PhotoUploadSectionContainer>
                    <PhotoUploadTypeSelectFooter handleSubmit={handleSubmit} />
                </>
            )}
        </>
    );
};

const PhotoUploadTypeSelect = () => {
    const history = useHistory();
    const location = useLocation();

    return (
        <PhotoUploadProviders>
            <RedirectOnInvalidReferrer />
            <PhotoUploadTypeSelectLayout
                history={history}
                location={location}
            />
        </PhotoUploadProviders>
    );
};

export default PhotoUploadTypeSelect;
